var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      !_vm.disabled
        ? _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增税率阶梯")]
          )
        : _vm._e(),
      _c(
        "vxe-table",
        { ref: "fineTable", attrs: { data: _vm.dataList } },
        [
          _c("vxe-column", {
            attrs: { type: "seq", title: "序号", width: "70" },
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "minAmount",
              title: "区间最小值（大于）",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: { disabled: _vm.disabled, min: 0 },
                      model: {
                        value: row.minAmount,
                        callback: function ($$v) {
                          _vm.$set(row, "minAmount", $$v)
                        },
                        expression: "row.minAmount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "maxAmount",
              title: "区间最大值（小于等于）",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row, rowIndex }) {
                  return [
                    _c("el-input-number", {
                      attrs: { disabled: _vm.disabled, min: 0 },
                      on: {
                        change: function ($event) {
                          return _vm.handleMaxAmountChange(row, rowIndex)
                        },
                      },
                      model: {
                        value: row.maxAmount,
                        callback: function ($$v) {
                          _vm.$set(row, "maxAmount", $$v)
                        },
                        expression: "row.maxAmount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "taxRate", title: "税率（%）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: { disabled: _vm.disabled, min: 0 },
                      model: {
                        value: row.taxRate,
                        callback: function ($$v) {
                          _vm.$set(row, "taxRate", $$v)
                        },
                        expression: "row.taxRate",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("vxe-table-column", {
                attrs: { width: "70", field: "createTime", title: "操作" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-button", {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1808526374
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _vm._v(
        " 1、设定的税率阶梯需满足连续性，即下一阶梯的区间最小值必须等于上一节点的区间最大值。"
      ),
      _c("br"),
      _vm._v(
        " 2、计算方式：单月单人的提现金额按阶梯分别计算需承担税金。红包提现产生的上浮服务费按打款时间时的提现情况进行计算。"
      ),
      _c("br"),
      _vm._v(" 3、至少需要设置一个税率阶梯，未设置税率阶梯的金额会打款失败。 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }